import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';
import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    IconButton,
    Input,
    InputGroup,
    InputRightElement,
} from '@chakra-ui/react';
import { useState } from 'react';

function ConfirmPasswordField({
    label = 'Confirm Password',
    isRequired = true,
    field,
    form,
    ...inputProps
}) {
    const [showPassword, setShowPassword] = useState(false);
    const isInvalid = Boolean(
        form.errors[field.name] && form.touched[field.name],
    );

    const handleToggleShowPassword = () => setShowPassword(!showPassword);

    return (
        <FormControl isRequired={isRequired} isInvalid={isInvalid}>
            <FormLabel htmlFor={field.name}>{label}</FormLabel>
            <InputGroup>
                <Input
                    {...field}
                    id={field.name}
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    placeholder="Confirm your password"
                    {...inputProps}
                />
                <InputRightElement h="full">
                    <IconButton
                        variant="ghost"
                        onClick={handleToggleShowPassword}
                        icon={
                            showPassword ? (
                                <ViewIcon boxSize="5" />
                            ) : (
                                <ViewOffIcon boxSize="5" />
                            )
                        }
                        aria-label={
                            showPassword ? 'Hide password' : 'Show password'
                        }
                        _focus={{
                            boxShadow: 'none',
                        }}
                        _hover={{
                            background: 'none',
                            color: 'brand.600',
                        }}
                        color={showPassword ? 'brand.600' : 'gray.500'}
                    />
                </InputRightElement>
            </InputGroup>
            <FormErrorMessage fontSize="sm" mt={1}>
                {form.errors[field.name]}
            </FormErrorMessage>
        </FormControl>
    );
}

export { ConfirmPasswordField };
